import { render, staticRenderFns } from "./ConnectCoinbasePro.vue?vue&type=template&id=09fb5fb8&"
import script from "./ConnectCoinbasePro.vue?vue&type=script&lang=js&"
export * from "./ConnectCoinbasePro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports